module.exports = __webpack_public_path__ + "img/9_14.ca89f60a.png";